/* ========================================================================
 * click in map
 * ======================================================================== */
DOMReady( function(){
  document.querySelectorAll(".map path").forEach((mapLink) => {
    mapLink.addEventListener('click', function(){
      if(mapLink.dataset.url){
        location.href = mapLink.dataset.url;
      }
    });
  });
});
